<template>
  <el-table :data="tableData.tableList" :row-key="getRowKeys" :expand-row-keys="expands" :size="size" :span-method="spanMethod"
            @selection-change="selectionChange" @expand-change="expandChange">
    <!--多选-->
    <el-table-column width="45" type="selection" v-if="tableData.isMultiple" align="center"></el-table-column>
    <!--序号-->
    <slot name="index"></slot>
    <!--列表项-->
    <template v-for="(item, index) in tableData.tableColumn">
      <el-table-column :key="index" :label="item.label" :width="item.width" :min-width="item.minWidth" :align="item.position || 'center'" :show-overflow-tooltip="item.tooltip">
<!--      多级表头-->
        <template v-for="(subItem, index) in item.multi">
          <el-table-column :key="index" :label="subItem.label" :width="subItem.width" :min-width="subItem.minWidth" align="center">
            <template slot-scope="scope">
              <slot :name="subItem.property" :row="scope.row">
                <span v-html="showTableData(subItem.property, scope.row, subItem.format)"></span>
              </slot>
            </template>
          </el-table-column>
        </template>
        <template slot-scope="scope">
<!--      需要自定义column时在父组件添加<template slot="属性名" slot-scope="scope">自定义内容</template>-->
          <slot :name="item.property" :row="scope.row">
<!--      后备内容-->
            <span v-html="showTableData(item.property, scope.row, item.format)"></span>
          </slot>
        </template>
      </el-table-column>
    </template>
    <!--展开项-->
    <el-table-column type="expand" v-if="tableData.hasExpand" label="更多" width="55">
      <template slot-scope="scope">
        <el-form label-position="left" class="table-expand" :label-width="tableData.expandLabelWidth + 'px'">
          <el-row :gutter="20">
            <template v-for="(item, index) in tableData.expandColumn">
              <el-col :span="12" :key="index">
                <el-form-item :label="item.label" >
                  <span v-if="item.formatFun" :title="item.formatFun(scope.row)">{{item.formatFun(scope.row)}}</span>
                  <span v-else v-html="showTableData(item.property, scope.row, item.format)"
                        :title="showTableData(item.property, scope.row, removeColor(item.format))"></span>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </template>
    </el-table-column>
<!--      操作栏-->
    <slot name="actionBar"></slot>
  </el-table>
</template>

<script>
export default {
  name: "vueTable",
  props: {
    size: {
      type: String,
      default: "",
    },
    tableData: Object,
    selectList: Array,
    spanMethod: Function,
  },
  data() {
    return {
      expands: []
    }
  },
  methods: {
    removeColor(list) {
      return list?.map(item => {
        return {id:item.id, msg:item.msg};
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    selectionChange(list) {
      this.$emit("update:selectList", list);
    },
    expandChange(row, expandedRows) {
      this.expands = [];
      if (expandedRows.length) {
        this.expands.push(row.id);
      }
    }
  }
}
</script>

<style scoped>

</style>
